<template>
  <div class="organizacao" id="organizacao">
    <b-container fluid>
      <h1 class="titulo">{{ $t('tituloOrganizacao') }}</h1>
      <b-img :src="svgTitulo" class="svgTitulo"></b-img>
    </b-container>

    <b-container class="bv-example-row bv-example-row-flex-cols">
      <b-row align-v="center" class="space">
        <b-col md="4">
          <b-img class="organizadorEmpresa organizadorCacc" v-bind:src="organizadorCacc"></b-img>
        </b-col>
        <b-col md="4">
          <b-img class="organizadorEmpresa organizadorCasi" v-bind:src="organizadorCasi"></b-img>
        </b-col>
        <b-col md="4">
          <b-img class="organizadorEmpresa organizadorDcc" v-bind:src="organizadorDcc"></b-img>
        </b-col>
      </b-row>
    </b-container>
    <b-container class="bv-example-row bv-example-row-flex-cols">
      <b-row align-v="center" class="justify-content-md-center">
        <b-col md="4">
          <b-img class="organizadorEmpresa organizadorComp" v-bind:src="organizadorComp"></b-img>
        </b-col>
        <b-col md="4">
          <b-img class="organizadorEmpresa organizadorEmakers" v-bind:src="organizadorEmakers"></b-img>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Roboto+Condensed");

html,
body {
  font-family: "Roboto Condensed", sans-serif;
}

#app {
  font-family: "Roboto Condensed", sans-serif;
}

.organizacao {
  /* background-image: url("~@/assets/Organizacao/background-organizacao-web.png"); */
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: -100px;
}

.svgTitulo {
  width: 175px;
  top: 50%;
  left: 50%;
  margin-bottom: 75px;
}

.titulo {
  padding-top: 160px;
  font-size: 1.6em;
  text-align: center;
  font-weight: 300;
  color: black;
}

.organizadorEmpresa {
  margin-bottom: 85px;
  height: 75px;
}

.organizadorComp {
  height: 45px;
}

.organizadorEmakers {
  height: 120px;
}

.organizadorDcc {
  height: 100px;
}
@media only screen and (max-width: 768px) {
  .organizacao {
    /* background: url("~@/assets/Organizacao/background-organizacao-web.png") no-repeat;*/
      
    background-size: 100% 100%;
  }

  .organizadorEmpresa {
    margin-bottom: 55px;
    height: 60px;
    width: auto;
  }

  .organizadorDcc {
    height: 80px;
  }

  .organizadorComp {
    text-align: center;
    height: 28px;
  }

  .organizadorEmakers {
    height: 70px;
    margin-top: 20px;
  }
}
@media only screen and (max-width: 414px) {
  .organizacao {
    /* background: url("~@/assets/Organizacao/background-organizacao-mobile.png")
      no-repeat; */
    background-size: 100% 100%;
  }
}
</style>

<script>
export default {
  name: "Organizacao",
  data() {
    return {
      svgTitulo: require("../assets/Organizacao/linhaTitulo.svg"),
      organizadorComp: require("../assets/Organizacao/compLogo.svg"),
      organizadorCacc: require("../assets/Organizacao/cacc.png"),
      organizadorEmakers: require("../assets/Organizacao/emakers.svg"),
      organizadorCasi: require("../assets/Organizacao/casi.png"),
      organizadorDcc: require("../assets/Organizacao/dcc.png")
    };
  }
};
</script>
